import * as types from './types'

export function initProjectcategories() {
    return dispatch => {
        return fetch(process.env.REACT_APP_APIHOST + '/wp-json/wp/v2/projectcategories?per_page=50')
            .then(response => response.json())
            .then(json => dispatch(receiveProjectcategories(json)));
    }
}

function receiveProjectcategories(json) {
    return {
        type: types.FETCH_PROJECTCATEGORIES_SUCCESS,
        projectcategories: json
    }
}


// WEBPACK FOOTER //
// ./src/actions/projectcategoriesActions.js